"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageConfigDeleteApi = pageConfigDeleteApi;
exports.pageConfigGetByCodeApi = pageConfigGetByCodeApi;
exports.pageConfigInfoApi = pageConfigInfoApi;
exports.pageConfigListApi = pageConfigListApi;
exports.pageConfigSaveApi = pageConfigSaveApi;
exports.pageConfigUpdateApi = pageConfigUpdateApi;
exports.pageConfigUpdateStatusApi = pageConfigUpdateStatusApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者,助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件,未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 分页查询配置列表
 * @param params
 */
function pageConfigListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/product/page/config/list',
    method: 'GET',
    params: params
  });
}

/**
 * 新增配置
 * @param data
 */
function pageConfigSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/product/page/config/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑配置
 * @param data
 */
function pageConfigUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/product/page/config/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除配置
 * @param id
 */
function pageConfigDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/product/page/config/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 查询配置详情
 * @param id
 */
function pageConfigInfoApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/product/page/config/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 根据产品编号查询配置
 * @param productCode
 */
function pageConfigGetByCodeApi(productCode) {
  return (0, _request.default)({
    url: '/admin/platform/product/page/config/get/by/code',
    method: 'GET',
    params: {
      productCode: productCode
    }
  });
}

/**
 * 更新配置状态
 * @param id
 * @param status
 */
function pageConfigUpdateStatusApi(id, status) {
  return (0, _request.default)({
    url: '/admin/platform/product/page/config/update/status',
    method: 'POST',
    params: {
      id: id,
      status: status
    }
  });
}